import React from 'react';
import { useHistory } from 'react-router';

// Utils
import PageUrlsUtil from 'Shared/utils/PageUrls.utils';
import { formatDate } from 'Shared/utils/DateTime.utils';

// Types
import { UpdateAiReportType } from 'Shared/types/UpdateAiReportType.type';

// Components
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import { WpBadge } from 'Wpds/components/badge';
import ReportDropdown from '../ReportDropdown/ReportDropdown';

// Styles
import './ReportListItem.scss';

type Props = {
  report: UpdateAiReportType;
};

const ReportListItem = ({ report }: Props) => {
  const history = useHistory();

  const title = report.name || 'Untitled';
  const updateAtString = formatDate(report.updatedAt, 'MMM Do, YYYY');

  const handleOnClick = () => {
    if (report.draft) {
      history.push(PageUrlsUtil.makeUpdateAiSettingPageUrl({ slug: report.updateAiSettingSlug }));
    } else {
      history.push(PageUrlsUtil.makeUpdateAiRportPageUrl({ slug: report.slug }));
    }
  };

  const baseClassName = 'ReportListItem';

  return (
    <WpContainer className={baseClassName} onClick={handleOnClick}>
      <WpContainerBody>
        <div className={`${baseClassName}__utility-bar`}>
          <span className={`${baseClassName}__utility-bar__time`}>Last Saved: {updateAtString}</span>
          {!report.draft && <ReportDropdown report={report} />}
        </div>
        <div className={`${baseClassName}__title-bar`}>
          <p className={`${baseClassName}__title-bar__title`}>{title}</p>
          {report.draft && (
            <div className={`${baseClassName}__title-bar__badge`}>
              <WpBadge color="blue">Draft</WpBadge>
            </div>
          )}
        </div>
      </WpContainerBody>
    </WpContainer>
  );
};

export default ReportListItem;
